import { AddressEntityType } from '$houdini';

export const AddressEntitiesByAddressLength = [
	AddressEntityType.COUNTRY,
	AddressEntityType.COUNTRY_SUBDIVISION,
	AddressEntityType.COUNTRY_SUBDIVISION_1,
	AddressEntityType.CITY,
] as const;
